import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { theme } from "./theme";

function App() {
  return (
    <ConfigProvider locale={zhCN} theme={theme}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </ConfigProvider>
  );
}

export default App;
